'use client';

import { cn } from '@/lib/utils';
import patches from '@/util/intlPatches';
import { Fragment } from 'react';
import { useIntl } from 'react-intl';

const Price = props => {
  const { locale } = useIntl();
  const { value, currencyCode, specialPrice, classes = {} } = props;

  const parts = patches.toParts.call(
    new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
    }),
    value,
  );

  const children = parts.map((part, i) => {
    const key = `${i}-${part.value}`;

    return <span key={key}>{part.value}</span>;
  });

  const specialPriceChildren = specialPrice
    ? patches.toParts
        .call(
          new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
          }),
          specialPrice,
        )
        .map((part, i) => {
          const key = `${i}-${part.value}`;

          return <span key={key}>{part.value}</span>;
        })
    : null;

  return (
    <Fragment>
      {children}
      {value < specialPrice && (
        <span className={cn('ml-[7px] text-sm leading-5 text-aba6a0 line-through', classes.specialPrice)}>
          {specialPriceChildren}
        </span>
      )}
    </Fragment>
  );
};

export default Price;
